import {Record} from 'immutable';
import moment from 'moment-timezone';

import {makeReducer, match} from 'web-app/util/redux';
import {getWeekDiff} from 'web-app/util/moment';

import * as Actions from './actions';

export class LessonPlansState extends Record<{
    isEditing: boolean;
    isRepublishing: boolean;
    isSavingDraft: boolean;
    draftHasUnsavedChanges: boolean;
    selectedDate: string;
    includeNotVisibleToParents: boolean;
}>({
    isEditing: false,
    isRepublishing: false,
    selectedDate: moment().format('YYYY-MM-DD'),
    isSavingDraft: false,
    draftHasUnsavedChanges: false,
    includeNotVisibleToParents: false,
}) {}

export default makeReducer<LessonPlansState>(
    [
        match(Actions.editLessonPlan, state => {
            return state.merge({
                isEditing: true,
            });
        }),
        match(Actions.editLessonPlanSuccess, state => {
            return state.merge({
                isEditing: false,
            });
        }),
        match(Actions.editLessonPlanFailed, state => {
            return state.merge({
                isEditing: false,
            });
        }),
        match(Actions.setSelectedDate, (state, {payload}) => {
            return state.merge({
                selectedDate: payload.date,
            });
        }),
        match(Actions.changeWeek, (state, {payload}) =>
            state.merge({
                selectedDate: moment(state.selectedDate)
                    .add(
                        getWeekDiff(
                            moment(payload.dateInWeek).day(moment(state.selectedDate).day()),
                            moment(state.selectedDate),
                        ),
                        'weeks',
                    )
                    .format('YYYY-MM-DD'),
            }),
        ),
        match(Actions.setIncludeNotVisibleToParents, (state, {payload}) => {
            return state.merge({
                includeNotVisibleToParents: payload.include,
            });
        }),
        match(Actions.lessonPlanDidChange, state => {
            return state.merge({
                draftHasUnsavedChanges: true,
            });
        }),
        match(Actions.saveLessonPlanDraft, state => {
            return state.merge({
                isSavingDraft: true,
            });
        }),
        match(Actions.saveLessonPlanDraftSuccess, state => {
            return state.merge({
                isSavingDraft: false,
                draftHasUnsavedChanges: false,
            });
        }),
        match(Actions.saveLessonPlanDraftFailed, state => {
            return state.merge({
                isSavingDraft: false,
            });
        }),
        match(Actions.republishLessonPlanSuccess, state => {
            return state.merge({
                draftHasUnsavedChanges: false,
            });
        }),
    ],
    new LessonPlansState(),
);
